module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/LogoWithLines.fff4510d.png";